import { createSlice } from '@reduxjs/toolkit';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const initialState = {
  failedDomains: [],
};

export const companyDomainsSlice = createSlice({
  name: 'list',
  initialState,
  reducers: {
    setFailedDomains: (state, action) => {
      Object.assign(state, { failedDomains: action.payload });
    },
  },
});

export const { setFailedDomains } = companyDomainsSlice.actions;

export default companyDomainsSlice.reducer;

export const failedDomainsSelector = (state) => state.list.failedDomains;

export const useFailedDomains = (closeOnLeave = false) => {
  const dispatch = useDispatch();
  const failedDomains = useSelector(failedDomainsSelector);

  useEffect(
    () => () => {
      if (closeOnLeave) {
        dispatch(setFailedDomains([]));
      }
    },
    [closeOnLeave, dispatch],
  );

  return { failedDomains, setFailedDomains: (domains) => dispatch(setFailedDomains(domains)) };
};
